import { $ } from './../../helpers/query'

export class SectionAnimationTemplate {
  constructor() {
    this.ANIM_DUR = 600;
    this.TRANS_DUR = 1400;
    this.EXTRA_DUR = 1000;
    this.fullpage = document.querySelector('#fullpage');
    this.videoBg = document.querySelector('#hero-video');
    this.videoBgImg = this.videoBg.querySelector('img, iframe, video');
    this.transitionStart = new Event('sectionTransitionStart');
    this.transitionEnd = new Event('sectionTransitionEnd');
  }

  setCssTransition(func) {
    this.fullpage.classList.add(`timing-func__${func}`)
  }

  resetCssTransition() {
    this.fullpage.classList.remove('timing-func__step-start')
    this.fullpage.classList.remove('timing-func__ease')
  }

  hideVideo() {
    this.videoBg.classList.add('hero-video--hidden')
    this.videoBg.classList.add('invisible')
    this.videoBgImg.classList.add('bg-img--zoomed-extra-max')
  }

  showVideo() {
    this.videoBg.classList.remove('hero-video--hidden')
    setTimeout(() => {
      this.videoBg.classList.remove('invisible')
      this.videoBgImg.classList.remove('bg-img--zoomed-extra-max')
    }, 10)
  }

  clonePrevSibling(initial) {
    if (initial.previousElementSibling) {
      const prev = initial.previousElementSibling.cloneNode(true);
      prev.removeAttribute('id')
      prev.removeAttribute('data-anchor')
      prev.classList.remove('fullpage__section')
      prev.classList.add('hidden-section')
      prev.classList.add('invisible')
      if (prev.querySelector('.hidden-section')) {
        $('.hidden-section', prev).remove()
      }
      initial.append(prev)
      return prev;
    } else {
      return null;
    }
  }

  cloneNextSibling(initial) {
    if (initial.nextElementSibling) {
      const next = initial.nextElementSibling.cloneNode(true);
      next.removeAttribute('id')
      next.removeAttribute('data-anchor')
      next.classList.remove('fullpage__section')
      next.classList.add('hidden-section')
      next.classList.add('invisible')
      if (next.querySelector('.hidden-section')) {
        $('.hidden-section', next).remove()
      }
      initial.append(next)
      return next;
    } else {
      return null;
    }
  }

}
